import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { Store, AppDispatch } from 'store';
import gtmCancellationReasonEvent from 'utils/gtm/gtmCancellationReasonEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import { setCancellationFlowStep, setCancellationResult } from '../slice';
import { CancellationFlowStep, CancellationResultType } from '../types';

const cancelSubscriptionOperation =
  (reason: string, comment?: string) => async (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();
    const { locale } = store.app;
    const { customerData } = store.customer;

    const reqBody = {
      reason,
      comment,
    };

    const data = (await apiRequest(
      endpoints.customerOpPlusV1Cancel,
      reqBody,
      HttpMethods.POST,
      'data',
    )) as CancellationResultType;

    if (data) {
      dispatch(setCancellationResult(data));
      dispatch(setCancellationFlowStep(CancellationFlowStep.cancelled));
      gtmSendEvent(gtmCancellationReasonEvent(reason, locale, customerData?.customerId));
    }
  };

export default cancelSubscriptionOperation;
